const COOKIE_NAME = 'firstSessionVisit';

function isFirstSessionVisit() {
    var first = smartPak.cookie.read(COOKIE_NAME);
    return !first || first !== 'true';
}

function setFirstSessionVisit() {
    smartPak.cookie.write(COOKIE_NAME, 'true');
}

export default function manageFirstVisit(){
    if(isFirstSessionVisit()){
        setFirstSessionVisit();
    }
}